export default [
  {
    id: 'basic',
    title: 'Leilões',
    icon: 'gavel',
    iconType: 'fa',
    iconStyle: 'solid',
    class: '',
    route: 'leiloes.lista'
  },
  {
    id: 'bens',
    title: 'Bens',
    icon: 'clipboard-list-check',
    iconType: 'fa',
    iconStyle: 'solid',
    class: '',
    route: 'bens.lista'
  },
  {
    id: 'arrematantes',
    title: 'Arrematantes',
    icon: 'user',
    iconType: 'fa',
    iconStyle: 'solid',
    class: '',
    route: 'arrematantes.lista'
  },
  {
    id: 'comitenetes',
    title: 'Comitentes',
    icon: 'building',
    iconType: 'fa',
    iconStyle: 'solid',
    class: '',
    route: 'comitentes.lista'
  },
  {
    id: 'mkt',
    title: 'Marketing',
    icon: 'megaphone',
    iconType: 'fa',
    iconStyle: 'solid',
    class: '',
    route: 'marketing.main'
  },
  {
    id: 'fin',
    title: 'Financeiro',
    icon: 'receipt',
    iconType: 'fa',
    iconStyle: 'solid',
    class: '',
    // route: 'marketing.main'
  },
  {
    id: 'tasks',
    title: 'Tarefas',
    icon: 'tasks',
    iconType: 'fa',
    iconStyle: 'solid',
    class: '',
    route: 'sl.tarefas.lista'
  },
  {
    id: 'relatorios',
    title: 'Relatórios',
    icon: 'file-alt',
    iconType: 'fa',
    iconStyle: 'light',
    class: '',
    route: 'relatorios.main'
  }
]
